import { Box, Typography, TextField, Divider } from '@mui/material'
import { useXRayAnnotations } from '../context/XRayAnnotationsContext'
import { xrayTypes } from 'pages/Diagnostics/constants/diagnostic_types'

/**
 * Componente que exibe todas as anotações médicas feitas nas imagens de raio-X
 * Mostra apenas as imagens que possuem anotações
 */
export const XRayAnnotationsSummary = () => {
  const { annotations } = useXRayAnnotations()

  // Filtra apenas anotações não vazias
  const activeAnnotations = Object.entries(annotations).filter(
    ([_, annotation]) => annotation.trim() !== ''
  )

  if (activeAnnotations.length === 0) {
    return null
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant='h6'
        sx={{ mb: 2, color: 'var(--primarySoft-button-color)' }}
      >
        Anotações Médicas por Imagem
      </Typography>

      {activeAnnotations.map(([imageId, annotation]) => {
        const imageName = xrayTypes[imageId]?.name || imageId

        return (
          <Box key={imageId} sx={{ mb: 2 }}>
            <Typography
              variant='subtitle2'
              sx={{ fontWeight: 'bold', mb: 1, color: 'primary.main' }}
            >
              {imageName}:
            </Typography>
            <TextField
              fullWidth
              multiline
              value={annotation}
              disabled
              variant='outlined'
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(0, 0, 0, 0.02)'
                }
              }}
            />
          </Box>
        )
      })}

      <Divider sx={{ mt: 3 }} />
    </Box>
  )
}
